import { Link } from "react-router-dom";

const LINKS = [
  { to: "/terms", label: "Terms of Service", testid: "footer-terms" },
  { to: "/privacy", label: "Privacy Policy", testid: "footer-privacy" },
  { to: "/dmca", label: "DMCA Policy", testid: "footer-dmca" },
  { to: "/copyright", label: "Report copyright", testid: "footer-copyright" },
  { to: "/tv", label: "Jixxeo on TV", testid: "footer-tv" },
];

export const SiteFooter = () => (
  <footer className="mx-auto max-w-7xl px-3 sm:px-6 mt-16 pt-6 pb-4 border-t border-white/5" data-testid="site-footer">
    <div className="flex flex-wrap gap-x-5 gap-y-2 text-xs text-white/50">
      {LINKS.map(l => <Link key={l.to} to={l.to} data-testid={l.testid} className="hover:text-[#00E7FF] transition-colors">{l.label}</Link>)}
    </div>
    <div className="text-[11px] text-white/30 mt-3">© {new Date().getFullYear()} Jixxeo Videos</div>
  </footer>
);
